import React from "react";
import { Container } from "react-bootstrap";

function LicenseInProgressPage() {
  const styleContainer = {
    height: "92vh",
    backgroundColor: "#f9f9f9",
    fontSize: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };
  return (
    <div style={{ height: "92vh" }}>
      <div style={styleContainer}>
        <Container>
          <h1 style={{ fontSize: "xxx-large", paddingBottom: "4%" }}>
            In progress
          </h1>
          <h4>Your site is not on test period yet.</h4>
          <h4>Please contact the project manager for more information</h4>
        </Container>
      </div>
    </div>
  );
}

export default LicenseInProgressPage;
